<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 12 9"
  >
    <path d="M10.59 8.16L6 3.58 1.41 8.16 0 6.75l6-6 6 6z"></path>
  </svg>
</template>
